// components
import CalendarContainer from './components/CalendarContainer/CalendarContainer';
import AppointmentFormVisibility from './components/AppointmentForm/AppointmentFormVisibility';
import Header from './components/Header/Header';

// hooks
import { useShallow } from 'zustand/shallow';
import useSelectedDateRange from 'components/roster-portal/activity-planning/hooks/useSelectedDateRange';
import { useMrpWebSocket } from './hooks/useMrpWebSocket';

// providers
import DialogProvider from 'components/shared/DialogProvider/DialogProvider';

// types
import { useEffect } from 'react';
import { omit } from 'lodash';

import {
  CalendarSection,
  Content,
  MultiResourceContainer
} from './MultiResourcePlanning.styles';

// store
import { useEntityStore } from './stores/entityStore/entityStore';
import { useAppointmentStore } from './stores/appointmentStore/appointmentStore';
import ShortcutProvider from 'components/shared/ShortcutProvider';
import { CalendarInteractionProvider } from './components/CalendarContainer/components/CalendarInteractionProvider/CalendarInteractionProvider';
import ContextPanel from './components/ContextPanel/ContextPanel';
import { useSelector } from 'react-redux';

const MultiResourcePlanning = () => {
  const { startDate, endDate } = useSelectedDateRange();
  const { hasHydrated, refetchPlanning, subscribers } = useEntityStore(
    useShallow((state) => ({
      hasHydrated: state.hasHydrated,
      refetchPlanning: state.control.fetch,
      subscribers: state.subscribers
    }))
  );
  const hasAddAppointmentAccess = useSelector(
    ({ grants }) => grants.hasAddAppointmentAccess
  );

  const appointment = useAppointmentStore(
    useShallow((state) => state.appointment)
  );

  useMrpWebSocket();

  /**
   * TODO: Should move this logic to the entity listener or the entity store itself
   */
  useEffect(() => {
    if (subscribers.length === 0 || (!startDate && !endDate)) return;

    refetchPlanning({
      planningEntityIdentifiers: subscribers.map((subscriber) =>
        omit(subscriber, 'isError', 'isLoading')
      ),
      startDate,
      endDate
    });
  }, [startDate, endDate, hasHydrated]);

  return (
    <ShortcutProvider>
      <DialogProvider>
        <CalendarInteractionProvider>
          <MultiResourceContainer>
            <CalendarSection fullWidth={!appointment}>
              <Header />

              <Content>
                <CalendarContainer />
                <ContextPanel isAppointmentOpen={!!appointment} />
              </Content>
            </CalendarSection>

            {hasAddAppointmentAccess && <AppointmentFormVisibility />}
          </MultiResourceContainer>
        </CalendarInteractionProvider>
      </DialogProvider>
    </ShortcutProvider>
  );
};

export default MultiResourcePlanning;
